export default {
    state: {
        navi: true,
        snackbar: {show: false, color: "green", y: 'bottom', x: null, mode: '', timeout: 4000, text: 'Hello, I\'m a snackbar'},
        logs:{
            headers:[
            ],
            records:[]
        },
    },
    getters: {},
    mutations: {
        setNavi (state, data){
            state.navi = data
        },
        toggleNavi (state){
            state.navi = !state.navi
        },
        setSnackbar (state, data){
            state.snackbar = data
        },
        setLogs (state, data){
            state.Logs.records = data
        }
    },
    actions: {
        setNavi ({commit}, data){
            commit('setNavi', data)
        },
        toggleNavi ({commit}){
            commit('toggleNavi')
        },
        setSnackbar ({commit}, data){
            commit('setSnackbar', data)
        },
        setLogs ({commit}, data){
            commit('setLogs', data)
        },
    }
}
